import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateUxpTransferBatchMutationVariables = Types.Exact<{
  input: Types.CreateTransferBatchInput;
}>;


export type CreateUxpTransferBatchMutation = { __typename?: 'Mutation', createTransferBatch?: { __typename?: 'CreateTransferBatchPayload', transferBatch: { __typename?: 'TransferBatch', id: string } } | null };


export const CreateUxpTransferBatch = /*#__PURE__*/ gql`
    mutation CreateUxpTransferBatch($input: CreateTransferBatchInput!) {
  createTransferBatch(input: $input) {
    transferBatch {
      id
    }
  }
}
    ` as unknown as DocumentNode<CreateUxpTransferBatchMutation, CreateUxpTransferBatchMutationVariables>;

          

          export const useCreateUxpTransferBatchMutation = (options?:MutationHookOptions<CreateUxpTransferBatchMutation, CreateUxpTransferBatchMutationVariables>) => useMutation(CreateUxpTransferBatch, options);
          

          export type CreateUxpTransferBatchMutationOptions = MutationHookOptions<CreateUxpTransferBatchMutation, CreateUxpTransferBatchMutationVariables>;

          

          export type CreateUxpTransferBatchMutationResult = ReturnType<typeof useCreateUxpTransferBatchMutation>[1];

          
